import { t as toggleBooleanAttribute } from './toggleBooleanAttribute-Cp5m6OeZ.js';

class CollapsibleElement extends HTMLElement {
  /** @type {HTMLElement} */ #controller = this.querySelector('[aria-controls]');
  /** @type {HTMLElement} */ #target = this.#controller.ariaControlsElements[0];
  /** @type {boolean} */ #staticOnDesktop = this.hasAttribute('data-static-on-desktop');
  /** @type {MediaQueryList} */ #desktopQuery = window.matchMedia('(min-width: 768px)');

  connectedCallback() {
    this.#controller.addEventListener('click', () => this.#handleClick());
  }

  #handleClick() {
    if (this.#staticOnDesktop && this.#desktopQuery.matches) return;

    toggleBooleanAttribute(this.#controller, 'aria-expanded');
    toggleBooleanAttribute(this.#target, 'aria-hidden');
  }
}

customElements.define('collapsible-element', CollapsibleElement);
